import React from 'react';
import Home from '../components/Home';
import Navigation from '../components/Navigation';

const ChatLogsPage = () => {
  return (
    <div className="min-h-screen bg-pl_bg_light_5">
      <Navigation />
      <Home />
    </div>
  );
};

export default ChatLogsPage; 